<div class="popup-container">
  <h2 mat-dialog-title>Filter Options</h2>

  <mat-dialog-content class="popup-content">
    <mat-card class="form-section">
      <mat-card-header>
        <mat-card-title>Directions</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="directionsForm" class="checkbox-form">
          <mat-checkbox [formControlName]="'x'" class="checkbox-item">
            X Direction
          </mat-checkbox>
          <mat-checkbox [formControlName]="'y'" class="checkbox-item">
            Y Direction
          </mat-checkbox>
          <mat-checkbox [formControlName]="'z'" class="checkbox-item">
            Z Direction
          </mat-checkbox>
        </form>
      </mat-card-content>
    </mat-card>

    <mat-card class="form-section">
      <mat-card-header>
        <mat-card-title>Cycles</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="cyclesForm" class="checkbox-form">
          <mat-checkbox [formControlName]="'PD'" class="checkbox-item">
            Primary drainage
          </mat-checkbox>
          <mat-checkbox [formControlName]="'PDFI'" class="checkbox-item">
            Primary drainage / First imbibition
          </mat-checkbox>
        </form>
      </mat-card-content>
    </mat-card>

    <mat-card class="form-section">
      <mat-card-header>
        <mat-card-title>Ranges</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="rangesForm" class="range-form">
          <div [formGroupName]="'interfacialTensionRange'" class="range-group">
            <p>Interfacial tension (N/m)</p>
            <div class="range-controls">
              <mat-form-field appearance="outline" class="range-control">
                <mat-label>Min</mat-label>
                <input matInput type="number" [formControlName]="'min'" />
                @if (interfacialTensionRangeMinControl.hasError('min')) {
                  <mat-error>
                    Value can't be negative.
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="range-control">
                <mat-label>Max</mat-label>
                <input matInput type="number" [formControlName]="'max'" />
                @if (interfacialTensionRangeMaxControl.hasError('min')) {
                  <mat-error>
                    Value can't be negative.
                  </mat-error>
                }
              </mat-form-field>

            </div>
            @if (interfacialTensionRangeGroup.hasError('range') &&
              interfacialTensionRangeMinControl.valid &&
              interfacialTensionRangeMaxControl.valid) {
              <p
                class="range-error"
                >
                Invalid range.
              </p>
            }
          </div>

          <div [formGroupName]="'primaryDrainageRange'" class="range-group">
            <p>Primary drainage cosine</p>
            <div class="range-controls">
              <mat-form-field appearance="outline" class="range-control">
                <mat-label>Min</mat-label>
                <input matInput type="number" [formControlName]="'min'" />
                @if (
                  primaryDrainageRangeMinControl.hasError('min') ||
                  primaryDrainageRangeMinControl.hasError('max')) {
                  <mat-error
                    >
                    Value should be in range from -1 to 1.
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="range-control">
                <mat-label>Max</mat-label>
                <input matInput type="number" [formControlName]="'max'" />
                @if (
                  primaryDrainageRangeMaxControl.hasError('min') ||
                  primaryDrainageRangeMaxControl.hasError('max')) {
                  <mat-error
                    >
                    Value should be in range from -1 to 1.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            @if (primaryDrainageRangeGroup.hasError('range') &&
              primaryDrainageRangeMinControl.valid &&
              primaryDrainageRangeMaxControl.valid) {
              <p
                class="range-error"
                >
                Invalid range.
              </p>
            }
          </div>

          <div [formGroupName]="'firstImbibitionRange'" class="range-group">
            <p>First imbibition cosine</p>
            <div class="range-controls">
              <mat-form-field appearance="outline" class="range-control">
                <mat-label>Min</mat-label>
                <input matInput type="number" [formControlName]="'min'" />
                @if (
                  firstImbibitionRangeMinControl.hasError('min') ||
                  firstImbibitionRangeMinControl.hasError('max')) {
                  <mat-error
                    >
                    Value should be in range from -1 to 1.
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="range-control">
                <mat-label>Max</mat-label>
                <input matInput type="number" [formControlName]="'max'" />
                @if (
                  firstImbibitionRangeMaxControl.hasError('min') ||
                  firstImbibitionRangeMaxControl.hasError('max')) {
                  <mat-error
                    >
                    Value should be in range from -1 to 1.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            @if (firstImbibitionRangeGroup.hasError('range') &&
              firstImbibitionRangeMinControl.valid &&
              firstImbibitionRangeMaxControl.valid) {
              <p
                class="range-error"
                >
                Invalid range.
              </p>
            }
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button (click)="onCancel()" class="btn btn-secondary btn-big">Cancel</button>
    <button
      color="primary"
      (click)="onConfirm()"
      [disabled]="!checkIfFiltersValid()"
      class="btn btn-primary btn-big"
      >
      Apply Filters
    </button>
  </mat-dialog-actions>
</div>
